import { filter, share, tap } from 'rxjs/operators';
import { createFieldRecord } from '../../../utils/data';
import { actionNames } from '../../transfer/control';
import { filterByActionType } from '../../utils';
export default (({ control$ }, _, name)=>{
    const action$ = control$.pipe(filterByActionType(actionNames.MANUAL_FOCUS)).pipe(tap(({ payload: { fieldName, fieldIndices, id = `${name}-${createFieldRecord(fieldName, fieldIndices)}` } })=>{
        document.getElementById(id).focus();
    }), // ignore action since it is side-effect only
    filter(()=>false), share());
    return action$;
});
